import { render } from "./ActiveEventPage.vue?vue&type=template&id=514f1539&scoped=true"
import script from "./ActiveEventPage.vue?vue&type=script&lang=js"
export * from "./ActiveEventPage.vue?vue&type=script&lang=js"

import "./ActiveEventPage.vue?vue&type=style&index=0&id=514f1539&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514f1539"]])

export default __exports__